import React from "react";
import { connect } from "react-redux";
import "rc-slider/assets/index.css";
import { Input, Row, InputGroup, InputGroupAddon, InputGroupText, Col, Label, TabContent } from "reactstrap";
import Select from "react-select";
import OptionSettings from "../Options/Settings/OptionSettings";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { validationTypes } from "../../../../../common/validationType";
import CondtionTypeList from "../../../../areas/form/conditions/components/CondtionTypeList";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { displayTypesQuestion, sortTypes } from "../../../../models/displayTypes";
import { tempLangConverter } from "../../../../../helpers/lanugageHelper";
import JirangoSwitch from "../../../../../components/UI/Switch/JirangoSwitch";
import { ElementTabGroup } from "../../../../components/editor/tools/EditorTabGroup";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { renderElementSettings } from "../../../../helpers/renderElementSettings";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { AlignmentButtonGroup } from "../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";
import { deepClone } from "../../../../../helpers/objectHelper";
import { FormGroup } from "@material-ui/core";

const checkboxLabelAlignmentStyles = [
  { value: "end", text: <SystemLabel name="EndPlacement" /> },
  { value: "start", text: <SystemLabel name="StartPlacement" /> },
  { value: "under", text: <SystemLabel name="UnderPlacement" /> },
  { value: "top", text: <SystemLabel name="TopPlacement" /> },
];

class QuestionSettings extends React.Component {
  state = { activeTab: new Array(2).fill("1"), isChange: false };
  componentDidMount() {
    this.setState({
      activeTab: new Array(2).fill("1"),
    });
  }
  componentWillUnmount() {
    this.timer = null;
  }

  handleSoftUpdate = (element) => {
    const { dispatch } = this.props;
    dispatch(formActions.updateFormElement(element));
  };
  toggle = (tabPane, tab) => {
    const newArray = this.state.activeTab.slice();
    newArray[tabPane] = tab;
    this.setState({
      activeTab: newArray,
    });
  };
  handleSlider(e, path) {
    const names = path.split(".");
    const selectedElement = Object.assign({}, this.props.selectedElement);

    if (path === "data.style.width") {
      selectedElement[names[0]][names[1]][names[2]] = e + "%";
    } else if (path === "data.titleWidth") {
      selectedElement.data.inputWidth = 100 - e;
      selectedElement[names[0]][names[1]] = e /* + '%' */;
    } else if (path === "data.inputWidth") {
      selectedElement.data.titleWidth = 100 - e;
      selectedElement[names[0]][names[1]] = e /* + '%' */;
    }
    this.handleSoftUpdate(selectedElement);
  }
  handleSelectOnChange = (options, path) => {
    const names = path.split(".");
    const selectedElement = Object.assign({}, this.props.selectedElement);

    selectedElement[names[0]][names[1]] = options.value;
    this.handleSoftUpdate(selectedElement);
  };
  handleChange = (e, val, path) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    let value = val !== null && val !== undefined ? val : e.target.value;
    if (e && e.target.value === "" && path === "props.length") {
      value = 0;
    }
    if (e && e.target.type === "checkbox") {
      value = e.target.checked;
    }
    if (path === "props.requiredMax" || path === "props.requiredMin") {
      value = parseInt(value);
    }
    if (names.length === 2) {
      element[names[0]][names[1]] = value;
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = value;
    } else if (names.length === 4) {
      element[names[0]][names[1]][names[2]][names[3]] = value;
    }
    this.handleSoftUpdate(element);
  };
  expandArea = (area) => {
    this.setState({ [area]: !this.state[area] });
  };
  render() {
    const { selectedElement, selectedOption, selectedContainer } = this.props.form;
    return (
      selectedElement &&
      selectedElement.data && (
        <React.Fragment>
          <div>
            <ElementTabGroup activeTab={this.state.activeTab[0]} toggle={this.toggle} />
            <TabContent className="editor-tabcontent" style={{ paddingBottom: "65px" }} activeTab={this.state.activeTab[0]}>
              {this.state.activeTab[0] === "1" && (
                <React.Fragment>
                  <ListExpansion footer={false} icon="fa fa-square" defaultExpanded={true} description="Content">
                    <div style={{ paddingTop: "10px" }}>
                      <Row
                        style={{
                          justifyContent: "center",
                          marginLeft: "2px",
                          width: "100%",
                        }}
                      >
                        <Col>
                          <Label>
                            <SystemLabel name="QuestionTitle" />
                          </Label>
                          {selectedElement.props.labels &&
                            selectedElement.props.labels.map((l, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <InputGroup className="mb-3">
                                    <InputGroupAddon addonType="prepend">
                                      <InputGroupText>
                                        <i className={`flag-icon flag-icon-${tempLangConverter(l.languageCode)}`} />
                                      </InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                      type="text"
                                      autoComplete="jirango-nofill"
                                      value={selectedElement.props.labels[index].text}
                                      placeholder="Label name.."
                                      onChange={(e) => this.handleChange(e, null, `props.labels.${index}.text`)}
                                    />
                                  </InputGroup>
                                </React.Fragment>
                              );
                            })}
                        </Col>
                      </Row>
                      <hr />
                      <Row>
                        <Col className="list-setting-item-title" style={{ display: "inline-flex" }}>
                          <Label>
                            <SystemLabel name="ShowSubInputX" />
                          </Label>
                        </Col>
                        <Col style={{ textAlign: "right" }}>
                          <JirangoSwitch onChange={(e) => this.handleChange(e, null, `data.showSubInput`)} isChecked={selectedElement.data.showSubInput !== true ? false : true} />
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col className="list-setting-item-title" style={{ display: "inline-flex" }}>
                          <Label>
                            <SystemLabel name="ShowSubLabelX" />
                          </Label>
                        </Col>
                        <Col style={{ textAlign: "right" }}>
                          <JirangoSwitch onChange={(e) => this.handleChange(e, null, `data.showSubLabel`)} isChecked={selectedElement.data.showSubLabel !== true ? false : true} />
                        </Col>
                      </Row>
                      <hr />
                      {selectedElement.props.type === "Text" ? (
                        <React.Fragment>
                          <Row>
                            <Col className="list-setting-item-title">
                              <Label>
                                <SystemLabel name="MinChars" />
                              </Label>
                            </Col>
                            <Col className="list-setting-item-input">
                              <Input type="number" onChange={(e) => this.handleChange(e, null, `data.minCharacters`)} value={selectedElement.data.minCharacters} />
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col className="list-setting-item-title">
                              <Label>
                                <SystemLabel name="MaxChars" />
                              </Label>
                            </Col>
                            <Col className="list-setting-item-input">
                              <Input type="number" onChange={(e) => this.handleChange(e, null, `data.maxCharacters`)} value={selectedElement.data.maxCharacters} />
                            </Col>
                          </Row>
                          <br />
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {selectedElement.data.displayType !== undefined && (
                            <Row>
                              <Col className="list-setting-item-title">
                                <Label>
                                  <SystemLabel name="DisplayType" />
                                </Label>
                              </Col>
                              <Col className="list-setting-item-input">
                                <Select
                                  classNamePrefix="jirango-select"
                                  className="jirango-select"
                                  options={displayTypesQuestion.map((t) => {
                                    return { value: t.value, label: t.label };
                                  })}
                                  id="name"
                                  value={displayTypesQuestion.find((t) => {
                                    return t.value === selectedElement.data.displayType;
                                  })}
                                  onChange={(selectedOption) => this.handleSelectOnChange(selectedOption, "data.displayType")}
                                />
                              </Col>
                            </Row>
                          )}
                          <br />
                          {selectedElement.data.sortType !== undefined && (
                            <Row>
                              <Col className="list-setting-item-title">
                                <Label>
                                  <SystemLabel name="SortType" />
                                </Label>
                              </Col>
                              <Col className="list-setting-item-input">
                                <Select
                                  classNamePrefix="jirango-select"
                                  className="jirango-select"
                                  options={sortTypes.map((t) => {
                                    return { value: t.value, label: t.label };
                                  })}
                                  id="name"
                                  value={sortTypes.find((t) => {
                                    return t.value === selectedElement.data.sortType;
                                  })}
                                  onChange={(selectedOption) => this.handleSelectOnChange(selectedOption, "data.sortType")}
                                />
                              </Col>
                            </Row>
                          )}
                          <hr />
                          <Row>
                            <Col className="list-setting-item-title">
                              <Label>
                                <SystemLabel name="RequiredMin" tagName="label" />
                              </Label>
                            </Col>
                            <Col className="list-setting-item-input">
                              <InputGroup className="mb-3">
                                <Input type="number" value={selectedElement.props.requiredMin} onChange={(e) => this.handleChange(e, null, `props.requiredMin`)} />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="list-setting-item-title">
                              <Label>
                                {" "}
                                <SystemLabel name="RequiredMax" tagName="label" />
                              </Label>
                            </Col>
                            <Col className="list-setting-item-input">
                              <InputGroup className="mb-3">
                                <Input type="number" value={selectedElement.props.requiredMax} onChange={(e) => this.handleChange(e, null, `props.requiredMax`)} />
                              </InputGroup>
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}

                      <hr />
                      {selectedElement.props.type === "Text" ? (
                        <Row>
                          <Col className="list-setting-item-title">
                            <Label>
                              <SystemLabel name="ValidationType" />
                            </Label>
                          </Col>
                          <Col className="list-setting-item-input">
                            <Select
                              classNamePrefix="jirango-select"
                              className="jirango-select"
                              options={validationTypes.map((t) => {
                                return { value: t.value, label: t.label };
                              })}
                              id="name"
                              value={validationTypes.find((t) => {
                                return t.value === selectedElement.data.validation.type;
                              })}
                              onChange={(selectedOption) => this.handleChange(null, selectedOption.value, "data.validation.type")}
                            />
                          </Col>
                        </Row>
                      ) : null}
                      <br />
                      <Row>
                        <Col className="list-setting-item-title">
                          <Label>
                            <SystemLabel name="ValidationMessage" />
                          </Label>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="list-setting-item-title">
                          <Input
                            type="textarea"
                            style={{ resize: "none", minHeight: "100px" }}
                            value={selectedElement.data.validation.message}
                            onChange={(e) => this.handleChange(e, null, `data.validation.message`)}
                          />
                        </Col>
                      </Row>
                    </div>
                  </ListExpansion>
                  <br />
                  {selectedOption && selectedElement.props.type === "Option" ? (
                    <React.Fragment>
                      <ListExpansion footer={false} icon="fa fa-square" description="OptionSelectedPanel">
                        <OptionSettings />
                      </ListExpansion>
                      <Row>
                        <Col
                          style={{
                            marginLeft: "22px",
                            marginTop: "5px",
                            fontStyle: "italic",
                          }}
                          className="list-setting-item-title"
                        >
                          <p className="text-muted" style={{ lineHeight: "initial" }}>
                            <SystemLabel name="SelectedOptionInfo" />
                          </p>
                        </Col>
                      </Row>
                    </React.Fragment>
                  ) : null}
                  <br />
                  {selectedContainer ? (
                    <React.Fragment>
                      {renderElementSettings(selectedContainer.type, selectedContainer, this.props.toggleConditionModal)}
                      <Row>
                        <Col
                          style={{
                            marginLeft: "22px",
                            marginTop: "5px",
                            fontStyle: "italic",
                          }}
                          className="list-setting-item-title"
                        >
                          <p className="text-muted" style={{ lineHeight: "initial" }}>
                            <SystemLabel name="ElementIsInContainerInfo" />
                          </p>
                        </Col>
                      </Row>
                    </React.Fragment>
                  ) : null}
                </React.Fragment>
              )}

              {this.state.activeTab[0] === "2" && (
                <ListExpansion footer={false} icon="fa fa-square" defaultExpanded={true} description="FieldPlacements">
                  <AlignmentButtonGroup onChange={this.handleChange} alignment={selectedElement.data.labelAlign} path="data.labelAlign" type={["left", "center", "right"]} />
                  <hr />
                  {selectedElement.props.type === "Option" && selectedElement.data.displayType === "CHECKBOX" ? (
                    <React.Fragment>
                      <Row>
                        <Col className="list-setting-item-title">
                          <Label>
                            <SystemLabel name="CheckboxLabelPlacement" />
                          </Label>
                        </Col>
                        <Col className="list-setting-item-input">
                          <Select
                            classNamePrefix="jirango-select"
                            className="jirango-select"
                            options={checkboxLabelAlignmentStyles.map((t) => {
                              return { value: t.value, label: t.text };
                            })}
                            id="name"
                            value={checkboxLabelAlignmentStyles.find((t) => {
                              return t.value === selectedElement.data.checkboxLabelPlacement;
                            })}
                            onChange={(selectedOption) => this.handleSelectOnChange(selectedOption, "data.checkboxLabelPlacement")}
                          />
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col className="list-setting-item-title" style={{ display: "inline-flex" }}>
                          <Label>
                            <SystemLabel name="HorizontalAlignment" />
                          </Label>
                        </Col>
                        <Col style={{ textAlign: "right" }}>
                          <JirangoSwitch onChange={(e) => this.handleChange(null, e.target.checked, `data.inline`)} isChecked={selectedElement.data.inline !== true ? false : true} />
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col className="list-setting-item-title" style={{ display: "inline-flex" }}>
                          <Label>
                            <SystemLabel name="HideCheckboxLabels" />
                          </Label>
                        </Col>
                        <Col style={{ textAlign: "right" }}>
                          <JirangoSwitch
                            onChange={(e) => this.handleChange(null, e.target.checked, `data.hideCheckboxLabels`)}
                            isChecked={selectedElement.data.hideCheckboxLabels !== true ? false : true}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col className="list-setting-item-title">
                          <p className="text-muted" style={{ lineHeight: "initial", marginTop: "0px" }}>
                            <SystemLabel name="HideCheckboxLabelsInfo" />
                          </p>
                        </Col>
                      </Row>
                      {/*     <br/> */}
                      {!selectedElement.data.hideCheckboxLabels ? (
                        <React.Fragment>
                          <Row>
                            <Col className="list-setting-item-title" style={{ display: "inline-flex" }}>
                              <Label>
                                <SystemLabel name="DisplayCheckboxRowAsHeader" />
                              </Label>
                            </Col>
                            <Col style={{ textAlign: "right" }}>
                              <JirangoSwitch
                                onChange={(e) => this.handleChange(null, e.target.checked, `data.displayCheckboxRowAsHeader`)}
                                isChecked={selectedElement.data.displayCheckboxRowAsHeader !== true ? false : true}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col className="list-setting-item-title">
                              <p className="text-muted" style={{ lineHeight: "initial", marginTop: "0px" }}>
                                <SystemLabel name="DisplayCheckboxRowAsHeaderInfo" />
                              </p>
                            </Col>
                          </Row>
                        </React.Fragment>
                      ) : null}

                      <br />
                      {selectedElement.data.optionSpacing !== undefined && (
                        <EditorSlider
                          value={parseFloat(selectedElement.data.optionSpacing)}
                          defaultValue={0}
                          unitChange={() => null}
                          onChange={this.handleChange}
                          units={["px"]}
                          activeUnit={"px"}
                          steps={1}
                          max={30}
                          min={-30}
                          path={"data.optionSpacing"}
                          label="OptionsSpacing"
                        />
                      )}
                    </React.Fragment>
                  ) : null}
                  <hr />
                  {selectedElement.data.padding !== undefined && (
                    <EditorSlider
                      value={selectedElement.data.padding}
                      defaultValue={0}
                      unitChange={() => null}
                      onChange={this.handleChange}
                      units={["px"]}
                      activeUnit={"px"}
                      steps={1}
                      max={100}
                      min={1}
                      path={"data.padding"}
                      label="Padding"
                    />
                  )}
                  <hr />
                  {selectedElement.data.titleWidth !== undefined && (
                    <EditorSlider
                      value={selectedElement.data.titleWidth}
                      defaultValue={0}
                      unitChange={() => null}
                      onChange={this.handleChange}
                      units={["%"]}
                      activeUnit={"%"}
                      steps={1}
                      max={100}
                      min={1}
                      path={"data.titleWidth"}
                      label="TitleColumnWidth"
                    />
                  )}
                  <hr />
                  {selectedElement.data.inputWidth !== undefined && selectedElement.props.type === "Text" ? (
                    <EditorSlider
                      value={selectedElement.data.inputWidth}
                      defaultValue={0}
                      unitChange={() => null}
                      onChange={this.handleChange}
                      units={["%"]}
                      activeUnit={"%"}
                      steps={1}
                      max={100}
                      min={1}
                      path={"data.inputWidth"}
                      label="FieldColumnWidth"
                    />
                  ) : null}
           {/*        <p>{selectedElement.props.type}</p>
                  <p>{selectedElement.data.displayType}</p> */}
                  {selectedElement.props.type === "Text" || (selectedElement.props.type == "Option" && selectedElement.data.displayType == "SELECT") ? (
                    <React.Fragment>
                      <hr />
                      <EditorSlider
                        value={selectedElement.data.style.width}
                        defaultValue={0}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={["%"]}
                        activeUnit={"%"}
                        steps={1}
                        max={100}
                        min={1}
                        path={"data.style.width"}
                        label="InnerWidth"
                      />
                    </React.Fragment>
                  ) : null}
                  {selectedElement.data.textRows !== undefined && selectedElement.props.type === "Text" && (
                    <Row>
                      <Col className="list-setting-item-title">
                        <Label>
                          <SystemLabel name="TextRows" />
                        </Label>
                      </Col>
                      <Col className="list-setting-item-input">
                        <Input type="number" onChange={(e) => this.handleChange(e, null, `data.textRows`)} value={selectedElement.data.textRows} />
                      </Col>
                    </Row>
                  )}
                </ListExpansion>
              )}
              <div style={{ display: this.state.activeTab[0] === "3" ? "unset" : "none" }}>
                <div>
                  <ListExpansion footer={false} icon="fa fa-square" defaultExpanded={true} description="RegistrationSettings">
                    <Col>
                      <FormGroup className="w-100">
                        <Label className="secondary-text" for="exampleEmail">
                          <SystemLabel name="Tags" />
                        </Label>
                        <Input type="textarea" onChange={(e) => this.handleChange(e, null, "props.tag")} value={selectedElement.props.tag} />
                      </FormGroup>
                      <p className="text-muted" style={{ lineHeight: "initial" }}>
                        <SystemLabel name="TagInfo" />
                      </p>
                    </Col>
                    <Row>
                      <Col className="list-setting-item-title" style={{ display: "inline-flex" }}>
                        <Label>
                          <SystemLabel name="ChangeLock" />
                        </Label>
                      </Col>
                      <Col style={{ textAlign: "right" }}>
                        <JirangoSwitch onChange={(e) => this.handleChange(e, null, `data.changeLock`)} isChecked={selectedElement.data.changeLock !== true ? false : true} />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="list-setting-item-title">
                        <p className="text-muted" style={{ lineHeight: "initial" /*  marginTop: "5px" */ }}>
                          <SystemLabel name="ChangeLockInstruction" />
                        </p>
                      </Col>
                    </Row>
                  </ListExpansion>
                  <br />
                  <ListExpansion footer={false} icon="fa fa-square" description="Conditions" defaultExpanded={true}>
                    <CondtionTypeList
                      // onSelect={this.toggleConditionModal}
                      element={selectedElement}
                      toggleConditionModal={this.props.toggleConditionModal}
                    />
                  </ListExpansion>
                </div>
              </div>
            </TabContent>
            <br />
          </div>
        </React.Fragment>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    form: state.form,
    selectedElement: state.form.selectedElement,
    event: state.event,

    rElement: state.element,
  };
}

export default connect(mapStateToProps)(QuestionSettings);
